import { Metadata } from 'next';

export const siteConfig = {
  title: 'Decodo',
  description: "Decodo's official website.",
  url: 'https://decodo.com',
  twitterCreator: '@decodo_com',
};

export const noFollowExclusions = [
  'decodo.com',
  'help.decodo.com',
  'https://www.scrapingdog.com'
];

export const metadata: Metadata = {
  verification: {
    other: {
      'facebook-domain-verification': '73ba5tvgxdpmh4nkkf4hbhn38no7p3',
    },
  },
};
